
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rekry",
      function () {
        return require("private-next-pages/rekry/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rekry"])
      });
    }
  